<p-paginator [showCurrentPageReport]="showCurrentPageReport" 
[currentPageReportTemplate]="currentPageReportTemplate"
(onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" 
[totalRecords]="totalRecords"
[rowsPerPageOptions]="rowsPerPageOption"></p-paginator>
